import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import Swiper from 'react-id-swiper';

import 'react-id-swiper/lib/styles/css/swiper.css';

import {
  ActionLink,
  ListChanelsButton,
  ProductInfo,
  ProductItem,
  ProductItemFooter,
  ProductItemWrapper,
  ProductPrice,
  ProductsListWrapper,
} from './ProductsComponents';
import {currencyFilter} from '../../lib/utils';
import {swiperMobileParams, swiperParams} from '../../lib/global-styles';
import {doShowModal} from '../../store/actions';
import Modal from '../Modal/Modal';
import ChannelsModal from '../ChannelsModal';
import {postMessageSender} from '../../lib/postMessager';

class ProductsList extends PureComponent {
  state = {
    selectedProduct: null,
    swiperMobileParams: { ...swiperMobileParams },
    swiperParams: { ...swiperParams },
  };

  getProductColor = key => {
    const index = this.props.currentProduct ? key + 1 : key;
    const mod = index % 4;

    switch (mod) {
      case 0:
        return 'pink';
      case 1:
        return 'lightPurple';
      case 2:
        return 'green';
      case 3:
        return 'purple';
      default:
        break;
    }
  };

  onListChannelsButtonClick = (e, product) => {
    e.preventDefault();
    const { target } = e.target.dataset;

    this.setState({
      selectedProduct: product,
    });
    this.props.onShowModal(target);

    postMessageSender({
      scrollTop: true,
    });
  };

  getProductAdditionalDescription = product => {
    if (product.isCombo && product.combo.channelQuantity) {
      const text = product.combo.channelQuantity > 1 ? 'canais' : 'canal';
      return (
        <p>
          + {product.combo.channelQuantity} {text} {product.combo.name}
        </p>
      );
    } else if (product.shortDescription) {
      return <p>{product.shortDescription}</p>;
    }
  };

  getProperProductName = product => {
    return product.friendlyName
  };

  render() {
    const { onProductClick } = this.props;
    const { selectedProduct, swiperParams, swiperMobileParams } = this.state;
    let { products } = this.props;

    return (
      <>
        <ProductsListWrapper>
          {products.map((product, key) => (
            <ProductItem key={key} color={this.getProductColor(key)}>
              <ProductItemWrapper>
                <ProductInfo>
                  <h3>{this.getProperProductName(product)}</h3>
                  {this.getProductAdditionalDescription(product)}
                  <Swiper {...swiperMobileParams}>
                    {product.images.map((image, key) => (
                      <img key={key} alt="canal" src={image} />
                    ))}
                  </Swiper>
                  <ProductPrice>
                    {currencyFilter(product.price)}
                    {'/mês'}
                  </ProductPrice>
                </ProductInfo>
                <ProductItemFooter>
                  <ListChanelsButton
                    onClick={e => this.onListChannelsButtonClick(e, product)}
                    data-target="channels-details"
                  >
                    {product.totalChannels} canais
                  </ListChanelsButton>
                  <ActionLink onClick={e => onProductClick(e, product, this.getProductColor(key))}>
                    Comprar
                  </ActionLink>
                </ProductItemFooter>
              </ProductItemWrapper>
              <Swiper {...swiperParams}>
                {product.images.map((image, key) => (
                  <img key={key} alt="canal" src={image} />
                ))}
              </Swiper>
            </ProductItem>
          ))}
          <Modal target="channels-details" targetClass="channels-details-modal" width={900}>
            {selectedProduct ? (
              <ChannelsModal
                channelsByCategory={selectedProduct.channelsByCategory}
                groupName={selectedProduct.groupName}
              />
            ) : null}
          </Modal>
        </ProductsListWrapper>
      </>
    );
  }
}

ProductsList.propTypes = {
  onShowModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  onShowModal: target => dispatch(doShowModal(target)),
});

export default connect(
  null,
  mapDispatchToProps,
)(ProductsList);
